const SVG_NS = 'http://www.w3.org/2000/svg';

/**
 * Factory pro vytváření SVG comic bubble elementů (foreignObject s textarea)
 * Separuje logiku vytváření DOM od event handlerů
 */
export default class SVGComicFactory {
  /**
   * Vytvoří SVG comic bubble foreignObject element (bez event handlerů)
   * @param {Object} config - konfigurace comic bubble
   * @param {string} config.id - ID textarea elementu
   * @param {Object} config.position - pozice {x, y}
   * @param {string} config.dataSvgCategory - kategorie (myslenka/promluva/vypravec)
   * @param {Array<string>} config.subject - orientace hran (např. ['bottom', 'right'])
   * @param {string} config.labelText - text labelu
   * @param {string} config.value - hodnota textarea
   * @param {boolean} config.clone - je to klon? (default: false)
   * @param {boolean} config.isClonedComic - je to clonovaný comic? (default: true)
   * @param {boolean} config.isPugGenerated - je to PUG-generovaný? (default: false)
   * @returns {SVGForeignObjectElement}
   */
  static create({
    id,
    position = { x: 0, y: 0 },
    dataSvgCategory = null,
    subject = null,
    labelText = '',
    value = '',
    clone = false,
    isClonedComic = true,
    isPugGenerated = false,
  }) {
    const fo = document.createElementNS(SVG_NS, 'foreignObject');

    // Base classes
    fo.classList.add('svg-text', 'svg-category');

    // Add category-specific class
    if (isPugGenerated) {
      fo.classList.add('svg-komiks-text');
    }

    if (dataSvgCategory) {
      fo.classList.add(`svg-komiks-${dataSvgCategory}`);
    }

    // Apply subject classes (bottom, right, etc.)
    if (subject && Array.isArray(subject)) {
      subject.forEach(cls => fo.classList.add(cls));
    }

    // Set attributes
    fo.setAttribute('data-svg-text', '');
    fo.setAttribute('x', position.x || 0);
    fo.setAttribute('y', position.y || 0);
    fo.setAttribute('width', '1');
    fo.setAttribute('height', '1');

    if (isPugGenerated) {
      fo.setAttribute('data-svg-comic', 'true');
    }

    if (subject && Array.isArray(subject)) {
      fo.setAttribute('data-svg-subject', subject.join(','));
    }

    // Create label div
    const label = document.createElement('div');
    label.className = 'svg-category-label';
    if (!isPugGenerated) {
      label.setAttribute('tabindex', '-1');
      label.style.outline = '0px';
    }
    label.textContent = labelText || '';

    // Create textarea
    const textarea = document.createElement('textarea');
    textarea.id = id;
    textarea.className = isPugGenerated ? 'svg-textarea do-not-remove' : 'svg-textarea';

    if (dataSvgCategory) {
      textarea.setAttribute('data-svg-category', dataSvgCategory);
    }

    if (isPugGenerated) {
      textarea.setAttribute('data-svg-comic', 'true');
    }

    if (isClonedComic) {
      textarea.setAttribute('data-cloned-from-comic', 'true');
    }

    if (clone) {
      textarea.setAttribute('data-svg-clone', 'true');
    }

    textarea.value = value || '';

    // Append children
    fo.appendChild(label);
    fo.appendChild(textarea);

    return fo;
  }
}
